import { Extension } from "../../core/extension";
import { createMaxLengthPlugin } from "./plugin";
/**
 * Adds a maximum length for the editor.
 * Works for typing and pasting content.
 *
 * We can't reliably count only textual characters, so we use the editor's doc size to limit entry.
 * That means each new node will count as 1 new character, at least.
 */
export class MaxLengthExtension extends Extension {
    constructor(maxLength) {
        super();
        this.maxLength = maxLength;
    }
    addPlugins(schema, plugins) {
        if (!this.maxLength) {
            return plugins;
        }
        return plugins.concat([createMaxLengthPlugin(this.maxLength + 2)]); // empty doc has content size of 2
    }
}
